import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListWarehouseMemberAccessesActions as Actions,
  ListWarehouseMemberAccessesRequestAction as RequestAction,
} from 'store/ducks/warehouseMemberAccesses';

export function* listWarehouseMemberAccessesRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('warehouse-member-accesses', {
      ...query,
      asList: 1,
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
